import './FansSummary.sass';

import { FC } from 'react';

export const FansSummarySkeleton: FC = () => (
  <div className="FansSummary FansSummary--skeleton">
    {[0, 1].map((i) => (
      <div className="FansSummary__item" key={i}>
        <div className="FansSummary__bar FansSummary__bar--value sk-shimmer" />
        <div className="FansSummary__bar FansSummary__bar--label sk-shimmer" />
      </div>
    ))}
  </div>
);
